<div class="row page-title">
  <span>{{ localizationConstants.TOOL_LOCATIONS_PAGE_TITLE | translate }}</span>
</div>

<div [hidden]="!companyService.selectedCompany">
  <div class="row">
    <div class="c-details col">
      <div class="c-details__action-button u-mt--large">
        <button
          (click)="openLocationCreateModal()"
          type="button"
          class="button button-primary button-block u-mobile">
          {{ localizationConstants.LOCATION_CREATE | translate }}
        </button>
        <button
          (click)="openLocationCreateModal()"
          type="button"
          class="button--sm button-primary u-tablet">
          {{ localizationConstants.LOCATION_CREATE | translate }}
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="isLoading"
    class="row center">
    <div class="col">
      <app-loading-icon
        class="u-color--light"
        size="2x"></app-loading-icon>
    </div>
  </div>
  <div
    [hidden]="dataSource.data?.length"
    class="row center">
    <div class="col">
      <h2>{{ localizationConstants.LOCATION_NO_LOCATIONS_FOUND | translate }}</h2>
    </div>
  </div>
  <div [hidden]="!dataSource.data?.length">
    <div class="row">
      <div class="col">
        <div
          class="o-grid u-pb--medium"
          [class.c-sticky]="selectedTools?.length > 0">
          <div class="o-grid__item col-12 col-md-3 col-sm-5 u-p-bottom-only">
            <form class="c-search-form--full">
              <div class="c-input-group">
                <input
                  type="text"
                  name="search"
                  id="input-search"
                  [(ngModel)]="dataSource.filter"
                  class="c-input c-input--beta"
                  placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
                  required />
                <input
                  *ngIf="dataSource.filter"
                  id="tool-location-items-search-clear"
                  (click)="dataSource.filter = ''"
                  class="c-button c-button--search c-close-search c-button--search--sm"
                  value="Clear" />
                <input
                  *ngIf="!dataSource.filter"
                  id="tool-location-items-search"
                  type="submit"
                  class="c-button c-button--search c-button--search--sm"
                  value="Search" />
              </div>
            </form>
          </div>
          <div class="o-grid__item col-md-6 col-sm-2 u-p-bottom-only"></div>
          <div class="o-grid__item col-12 col-md-3 col-sm-5 u-p-bottom-only">
            <mat-select
              [(ngModel)]="currentAction"
              (ngModelChange)="onActionsClick()"
              class="c-select c-select--md"
              [disabled]="!selectedTools?.length">
              <mat-option
                value="Default"
                disabled>
                {{ localizationConstants.LOCATION_ACTIONS | translate }}
              </mat-option>
              <mat-option value="Update">
                {{ localizationConstants.LOCATION_CHANGE | translate }}
              </mat-option>
              <mat-option value="Remove">
                {{ localizationConstants.LOCATION_REMOVE_TOOL | translate }}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div
          id="location-details"
          class="col bg-white u-shadow u-scroll--horizontal">
          <div
            id="tool-locations-table"
            class="tool-locations-table col">
            <table
              mat-table
              [dataSource]="dataSource"
              matSort
              multiTemplateDataRows
              class="c-table c-table--expandable">
              <ng-container matColumnDef="locationNameAndDescription">
                <th
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  width="50%">
                  {{ localizationConstants.TOOL_LOCATION | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let location"
                  (click)="toggleExpandRow(location)"
                  class="c-table__group-header"
                  [class.is-toggled]="location.expanded"
                  [class.c-clickable]="location.tools.length">
                  <i
                    *ngIf="location.tools.length"
                    class="c-icon c-icon--toggle"></i>
                  <i
                    *ngIf="!location.tools.length"
                    class="c-icon c-icon--toggle-disabled"></i>
                  <span class="location-name">
                    {{ location.locationName
                    }}{{ location.locationDescription ? " - " + location.locationDescription : "" }}
                    |
                    {{
                      localizationConstants.LOCATION_TOOLS_COUNT
                        | translate: { value: location.tools.length }
                    }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="action1">
                <th
                  mat-header-cell
                  *matHeaderCellDef></th>
                <td
                  mat-cell
                  *matCellDef="let location"
                  class="c-table__group-header">
                  <button
                    (click)="openLocationEditModal(location)"
                    type="button"
                    class="button--sm button-primary button-block">
                    {{ localizationConstants.BUTTON_EDIT | translate }}
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="action2">
                <th
                  mat-header-cell
                  *matHeaderCellDef></th>
                <td
                  mat-cell
                  *matCellDef="let location"
                  class="c-table__group-header">
                  <button
                    (click)="openLocationDeleteModal(location)"
                    type="button"
                    class="button--sm button-primary button-block">
                    {{ localizationConstants.BUTTON_DELETE | translate }}
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="locationToolsDetails">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  {{ localizationConstants.TOOLS_LOCATION | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let location"
                  colspan="3"
                  class="expandable-row-detail-cell">
                  <div [@detailExpand]="location.expanded ? 'expanded' : 'collapsed'">
                    <table
                      #expandedRowDetailTable
                      mat-table
                      matSort
                      #nestedMatSort="matSort"
                      [dataSource]="getToolsDataSource(location.tools, nestedMatSort)"
                      class="detail-table">
                      <ng-container matColumnDef="toolId">
                        <th
                          mat-header-cell
                          mat-sort-header
                          *matHeaderCellDef>
                          {{ localizationConstants.LOCATION_TOOLS_AT_LOCATION | translate }}
                        </th>
                        <td
                          mat-cell
                          *matCellDef="let tool"
                          width="40%">
                          <label class="c-input-checkbox-label-right c-label c-label--md">
                            <mat-checkbox
                              [(ngModel)]="tool.selected"
                              class="c-input-checkbox">
                            </mat-checkbox>
                            <span>
                              {{ tool.toolId
                              }}{{ tool.modelNumber ? " - " + tool.modelNumber : "" }}
                            </span>
                          </label>
                        </td>
                      </ng-container>
                      <tr
                        mat-header-row
                        *matHeaderRowDef="['toolId']"></tr>
                      <tr
                        mat-row
                        *matRowDef="let row; columns: ['toolId']"></tr>
                    </table>
                  </div>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="['locationNameAndDescription', 'action1', 'action2']"></tr>
              <tr
                mat-row
                *matRowDef="
                  let location;
                  columns: ['locationNameAndDescription', 'action1', 'action2']
                "
                class="c-table__row"></tr>
              <tr
                mat-row
                *matRowDef="
                  let location;
                  columns: ['locationToolsDetails'];
                  when: isExpansionDetailRow
                "
                class="expandable-row"
                [class.expanded-row]="location.expanded"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <mat-paginator
        [showFirstLastButtons]="true"
        [pageSize]="10"
        [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
    </div>
  </div>
</div>
